<div class="font-semibold readonly" readonly="readonly" pTooltip="{{toolTipMessage}}" tooltipPosition="{{tooltipPosition}}">
    {{readonlyText}}
</div>
